import React from 'react'
import '../style.css'
import { Typography } from '@material-ui/core'
const NoData = () => {
  return (
    <div className="no-data-div">
            <Typography style={{ fontWeight: "800" }}>
              No Data Available
            </Typography>
          </div>
  )
}

export default NoData








